import axios from 'axios'

export const getOnboardingStatus = () => {
  return axios.get('/onboarding/status')
}

export const getMyLoOnboardingSteps = () => {
  return axios.get('/lo-onboarding/my-onboarding-steps')
}

export const startLoOnboarding = (experience) => {
  return axios.post('/lo-onboarding/start', { experience })
}

export const completeLoOnboardingActivity = (activityId) => {
  return axios.post(`/lo-onboarding/activities/${activityId}/complete`)
}
